import { render, staticRenderFns } from "./DriverCarInfo.vue?vue&type=template&id=082e6abe&scoped=true&"
import script from "./DriverCarInfo.vue?vue&type=script&lang=js&"
export * from "./DriverCarInfo.vue?vue&type=script&lang=js&"
import style0 from "./DriverCarInfo.vue?vue&type=style&index=0&id=082e6abe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e6abe",
  null
  
)

export default component.exports